import { IS_SET } from './check.util'

export const TRIM_OBJECT = (_: { object: any, depth?: number }): any => {
  const o: any = _.object
  const res: any = {}
  const depth: number = _.depth ?? Number.MAX_SAFE_INTEGER

  // if (IS_SET(res)) {
  //   Object.keys(res).forEach(k => {
  //     if ((typeof res[k] === 'undefined') || (res[k] === null)) {
  //       delete res[k]
  //     } else if (depth > 0) {
  //       if (Array.isArray(res[k])) {
  //         res[k] = res[k].map((row: any) => trimObject({ object: row, depth: depth - 1 }))
  //       } else if ((typeof res[k]) === 'object') {
  //         trimObject({ object: res[k], depth: depth - 1 })
  //       }
  //     }
  //   })
  // }

  if (IS_SET(o)) {
    Object.keys(o as Record<string, any>).forEach(k => {
      if ((typeof o[k] !== 'undefined') && (o[k] !== null) && (depth > 0)) {
        if (Array.isArray(o[k])) {
          res[k] = o[k].map((row: any) => TRIM_OBJECT({ object: row, depth: depth - 1 }))
        } else if (typeof o[k] === 'object') {
          res[k] = TRIM_OBJECT({ object: o[k], depth: depth - 1 })
        } else {
          res[k] = o[k]
        }
      }
    })
  }

  return res
}

export const GET_OBJECT_KEY_LIST = <T> (o: T): Array<keyof T> => Object.keys(o as any) as any

export type OBJECT_ENTRY_LIST_TYPE<T> = Array<{ [K in keyof T]: [K, T[K]] }[keyof T]>

export const GET_OBJECT_ENTRY_LIST = <T> (o: T): OBJECT_ENTRY_LIST_TYPE<T> => Object.entries(o as any) as any
